<app-entity-mat-dialog-title title="Payment Methods"></app-entity-mat-dialog-title>

<div mat-dialog-content>
  <p class="text-muted">
    Drag to set the order staff see when entering a payment. Hidden methods no longer appear
    when entering new payments. Existing payments, reports, and imports are not affected.
  </p>
  <app-payment-methods-form [showSaveButton]="false"></app-payment-methods-form>
</div>

<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" mat-dialog-close type="button">Close</button>
  <button mat-raised-button color="primary" type="button"
          [disabled]="form?.showProgressSpinner || form?.visibleCount === 0"
          (click)="form?.onSubmit()">
    <mat-icon>save</mat-icon>
    Save Payment Methods
  </button>
</mat-dialog-actions>
